import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import '../styles/_styles.scss';
import PlazaInfoPanel from '../components/PlazaInfoPanel/PlazaInfoPanel';
import LogView from '../../../../PlazaView/components/LogEvents/components/LogView';
import { getMockEventsForEdgeController } from '../lib/plazaEventsGenerator';
import { mockEdgeControllers } from '../../../mocks/mockEdgeControllers';

function EdgeControllerPlaza({ edgeControllerId }) {
  const [events, setEvents] = useState([]);
  const [opened, setOpened] = useState([]);

  useEffect(() => {
    const edgeController = mockEdgeControllers.find((ec) => ec.edgeControllerId === edgeControllerId);
    const plazaId = edgeController?.plazaId;

    if (plazaId) {
      const mockEvents = getMockEventsForEdgeController(plazaId);
      setEvents(mockEvents);
    } else {
      setEvents([]);
    }
  }, [edgeControllerId]);

  const toggleOpen = (id) => {
    if (id) {
      if (opened.includes(id)) {
        setOpened(opened.filter((e) => e !== id));
      } else {
        setOpened([...opened, id]);
      }
    }
  };

  const edgeController = mockEdgeControllers.find((ec) => ec.edgeControllerId === edgeControllerId);
  const hasPlaza = !!edgeController?.plazaId;

  return (
    <div className="plaza-tab-content" style={{ width: '100%', maxHeight: 'calc(100dvh - 177px)' }}>
      <div className="plaza-tab-layout">
        <div className="plaza-info-section">
          <PlazaInfoPanel edgeControllerId={edgeControllerId} />
        </div>

        <div className="plaza-events-section">
          <Card className="events-card">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Plaza Events
              </Typography>

              {!hasPlaza ? (
                <div className="no-events-message">
                  <Typography variant="body1" color="textSecondary">
                    No plaza events available
                  </Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                    Assign this edge controller to a plaza to view charging events.
                  </Typography>
                </div>
              ) : events.length === 0 ? (
                <div className="no-events-message">
                  <Typography variant="body1" color="textSecondary">
                    There are no events for the last 24 hours
                  </Typography>
                </div>
              ) : (
                <div className="logs-list">
                  {events.map((log) => (
                    <LogView key={log.uuid} data={log} toggleOpen={toggleOpen} isNew={false} opened={opened.includes(log.uuid)} />
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default EdgeControllerPlaza;
